import { CREATE_LIST, CLEAR_LIST, OPEN_LIST, CLOSE_LIST } from '../actions/types';

const initialState = {
  dialogOpen: false,
  dialogTitle: '',
  changeList: []
}

function adminList(state = initialState, action){
  switch(action.type){
    case CREATE_LIST: {
      return {
        ...state,
        dialogTitle: action.payload.title,
        changeList: action.payload.list
      }
    }
    case OPEN_LIST: {
      return {
        ...state,
        dialogOpen: true
      }
    }
    case CLOSE_LIST: {
      return {
        ...state,
        dialogOpen: false
      }
    }
    case CLEAR_LIST: {
      return initialState;
    }
    default:
      return state;
  };
}

export default adminList;